import { render, staticRenderFns } from "./RecoveryUserForm.vue?vue&type=template&id=ebb546ec&scoped=true"
import script from "./RecoveryUserForm.vue?vue&type=script&lang=js"
export * from "./RecoveryUserForm.vue?vue&type=script&lang=js"
import style0 from "./RecoveryUserForm.vue?vue&type=style&index=0&id=ebb546ec&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb546ec",
  null
  
)

export default component.exports